import { DashboardEditor } from '../v2/dashboardEditor';

export const DashboardV2Page = () => <DashboardEditor />;
